import * as React from 'react';
const RadioGroupContext = React.createContext(undefined);
export const RadioGroupContextProvider = RadioGroupContext.Provider;
export default RadioGroupContext;
export const RadioOptionTypeContext = React.createContext(undefined);
export const RadioOptionTypeContextProvider = RadioOptionTypeContext.Provider;
